exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grouped-form .v-text-field {\n  border: 1px solid #e4e5e7;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 130%;\n}\n", ""]);

// exports
